import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';

import SpacingSchema from './schema';

const SpacingData = (props) => {
  const { data, block, onChangeBlock, blocksErrors } = props;

  const schema = SpacingSchema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

SpacingData.propTypes = {
  data: PropTypes.shape({
    size: PropTypes.string,
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default SpacingData;
